export { default } from './UploadAsModal';